// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';

const vuetify = createVuetify({
    components: {},
});

export default vuetify;